export default __webpack_public_path__ + "static/media/Discord.fb294f7f.svg";